
import { defineComponent, watchEffect } from "vue";
import { ref } from "vue";

export default defineComponent({
  name: "CheckboxWeekDays",
  emits: ["update:select-days"],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    selectedDays: {
      type: Array,
      default: [],
    },
  },
  setup(props, { emit }) {
    const selectedDays = ref([]);

    const getSelectedDays = () => {
      emit("update:select-days", selectedDays.value);
    };

    watchEffect(() => {
      getSelectedDays();
    });

    return { selectedDays, getSelectedDays };
  },
  data() {
    return {
      selectedDays: [] as any,
      noDaysSelected: false,
      weekDays: [
        { name: "domingo", label: "D", value: 0 },
        { name: "segunda", label: "S", value: 1 },
        { name: "terça", label: "T", value: 2 },
        { name: "quarta", label: "Q", value: 3 },
        { name: "quinta", label: "Q", value: 4 },
        { name: "sexta", label: "S", value: 5 },
        { name: "sabado", label: "S", value: 6 },
      ],
    };
  },
});
